import { DeleteOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Card, Modal, Popconfirm, Upload } from "antd";
import Cookies from "js-cookie";
import { useState } from "react";
import { MdFilePresent } from "react-icons/md";
import apiFactory from "../../api";
import { PreviewFile } from "../../components/chat/PreviewFile";
import { PreviewVideoContent } from "../../components/chat/PreviewVideoContent";
import { MESSAGE_STATUS } from "../../config/Constant";
import { useUploadFileStore } from "../../store/UploadFileStore";
import { useInfoUser } from "../../store/UserStore";
import {
  audioTypes,
  openNotificationError,
  videoTypes,
} from "../../utils/Utils";
import { ImagePreview } from "./ImagePreview";

function UploadFile({
  task,
  permissionCurrentUser,
  uploadFile,
  filesPreview,
  setFilesPreview,
  isSideBarTimeline,
  isMobile,
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { uploadFilesTask } = useUploadFileStore((state) => state);
  const { languageMap } = useInfoUser();

  const confirmDeleteFile = (file) => {
    deleteFile(file);
  };

  const deleteFile = async (file) => {
    const body = {
      code: file.code,
      taskPath: task?.path,
    };
    try {
      let response = await apiFactory.projectFile.delete(body);
      if (response.status === 200) {
        setFilesPreview((prevState) =>
          prevState.filter((s) => s.code !== file.code)
        );
      } else {
        openNotificationError(response.message);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getUrl = (file) => {
    return (
      process.env.REACT_APP_FILE_STORE +
      "/task/" +
      file.taskCode +
      file?.storageFileName +
      "?token=" +
      Cookies.get("access_token")
    );
  };

  const getFile = (file) => {
    return {
      originalName: file?.attachFileName,
      volume: file?.size,
      pathUrl: file.storageFileName,
      duration: file?.duration,
      previewVideoImage: file?.previewVideoImage,
      resourceId: file?.resourceId,
      videoImgResourceId: file?.videoImgResourceId,
    };
  };

  const isImage = (file) => {
    const validImageExtensions = [
      "jpg",
      "jpeg",
      "png",
      "gif",
      "bmp",
      "webp",
      "svg",
      "tiff",
    ];

    const validImageMimeTypes = [
      "image/jpeg",
      "image/png",
      "image/gif",
      "image/bmp",
      "image/webp",
      "image/svg+xml",
      "image/tiff",
    ];

    const fileName = file?.attachFileName.toLowerCase();
    return (
      validImageExtensions.some((ext) => fileName.endsWith(`.${ext}`)) ||
      validImageMimeTypes.includes(file.type)
    );
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const getExtension = (file) => {
    return file?.attachFileName
      .toLowerCase()
      ?.substring(file?.attachFileName.toLowerCase()?.lastIndexOf(".") + 1)
      .toLowerCase();
  };

  const isVideo = (file) => {
    return videoTypes.includes(getExtension(file));
  };

  const isAudio = (file) => {
    return audioTypes.includes(getExtension(file));
  };

  const getFileType = (file) => {
    if (isImage(file)) return MESSAGE_STATUS.IMAGE;
    if (isVideo(file)) return MESSAGE_STATUS.VIDEO;
    if (isAudio(file)) return MESSAGE_STATUS.AUDIO;
    return MESSAGE_STATUS.FILE;
  };

  const renderFilePreview = (file) => {
    if (!file) return;

    const fileType = getFileType(file);

    switch (fileType) {
      case MESSAGE_STATUS.IMAGE:
        return <ImagePreview file={file} />;
      case MESSAGE_STATUS.VIDEO:
        return (
          <div className="flex">
            <div className="relative">
              <PreviewVideoContent
                content={file?.storageFileName}
                selectedConversation={{ conversationId: task.taskCode }}
                isSelf={true}
                file={getFile(file)}
                path="task"
              />
            </div>
          </div>
        );
      case MESSAGE_STATUS.FILE:
      default:
        return (
          <PreviewFile
            contentType={MESSAGE_STATUS.FILE}
            content={file?.storageFileName}
            selectedConversation={{ conversationId: task.taskCode }}
            totalVolume={0}
            file={getFile(file)}
            path="task"
          />
        );
    }
  };

  return (
    <div>
      <div className="mt-1 ">
        <div
          className={`flex items-center right-[10px] sm:right-[10px] md:right-[412px] lg:right-[512px] ${isSideBarTimeline ? "fixed bottom-[10px]" : ""
            }`}
        >
          <Button
            className="flex items-center mr-2"
            onClick={showModal}
            disabled={
              filesPreview?.length === 0 ||
              !permissionCurrentUser?.includes("U")
            }
          >
            <MdFilePresent
              className="cursor-pointer"
              size={20}
              color={filesPreview?.length === 0 ? "#ccc" : "#3269c9"}
            />{" "}
            {filesPreview?.length}
          </Button>

          <Upload
            className="self-end"
            name="file"
            multiple={true}
            showUploadList={false}
            beforeUpload={() => false}
            onChange={uploadFile}
          >
            <Button
              icon={<UploadOutlined />}
              type="primary"
              disabled={!permissionCurrentUser?.includes("U")}
            >
              {languageMap?.["Sidebartimeline.buttonUpload"] ?? "Upload"}
            </Button>
          </Upload>
        </div>
      </div>
      {uploadFilesTask?.map((item) => {
        if (item?.taskCode === task?.taskCode) {
          return (
            <PreviewFile
              requestUuid={item?.requestUuid}
              content={item?.path}
              file={{
                volume: item?.volume,
                originalName: item?.fileName,
                resourceId: item?.resourceId,
                pathUrl: item?.path,
              }}
              contentType={item?.contentType}
              percentProgress={Math.round(
                (item?.totalChunkUploaded * 100) / item?.totalChunk
              )}
              totalVolume={item?.totalVolume}
              path={"task"}
            />
          );
        }

        return <></>;
      })}
      <div className="mt-1">
        {isModalOpen && (
          <Modal
            title="Attach File"
            width={500}
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={[]}
          >
            <div className="max-h-[600px] overflow-auto">
              {filesPreview?.length > 0 ? (
                <div>
                  {filesPreview
                    .sort(
                      (s1, s2) =>
                        new Date(s2.createdAt).getTime() -
                        new Date(s1.createdAt).getTime()
                    )
                    .map((file) => (
                      <div
                        key={file?.code + file?.taskCode}
                        className="h-full pb-1"
                      >
                        <div className="mx-1 h-full">
                          <Card
                            className="m-0 p-0 h-full flex flex-col justify-between"
                            hoverable
                            cover={
                              <div className="relative">
                                <Popconfirm
                                  description={
                                    languageMap?.["delete.file"] ??
                                    "Are you sure to delete this file?"
                                  }
                                  onConfirm={() => confirmDeleteFile(file)}
                                >
                                  <div
                                    className="absolute"
                                    style={{
                                      top: "2px",
                                      right: "0.4rem",
                                      zIndex: "1",
                                    }}
                                  >
                                    <div
                                      className="p-1 bg-white rounded-full flex items-center justify-center hover:bg-blue-200 "
                                      style={{ width: "24px", height: "24px" }}
                                    >
                                      <DeleteOutlined
                                        style={{ color: "red" }}
                                      />
                                    </div>
                                  </div>
                                </Popconfirm>

                                {renderFilePreview(file)}
                              </div>
                            }
                          ></Card>
                        </div>
                      </div>
                    ))}
                </div>
              ) : (
                <h3>No file attach</h3>
              )}
            </div>
          </Modal>
        )}
      </div>
    </div>
  );
}

export default UploadFile;
